import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Rate, Row, Typography } from 'antd';
import { CalendarOutlined, CheckCircleFilled, ClockCircleOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { FaRegStar } from 'react-icons/fa'; // Assuming you are using react-icons for star
import './style.css';
import { SlCalender } from 'react-icons/sl';
import { FaCheck } from "react-icons/fa6";
import acceptedEngagement from '../../../assets/images/acceptedEngagement.png'
import requestedEngagement from '../../../assets/images/Jobs1.png'
import { useParams } from 'react-router';
import { ApiCaller } from '../../../config';
import { Loader, ProfileImage } from '../../../components';
import moment from 'moment';
import BookingFrequencyChart from './frequencyBookingGraph';
import ResponseRateChart from './responseRateGraph';
import AverageSpendPerBooking from './avgSpendPerBookingGraph';
import WeeklyResponseRateChart from './responseRateGraph';

const { Title, Text } = Typography;

const accountStatus = {
    0: "Pending",
    1: "Completed",
    2: "Rejected",
    3: "Accepted",
    4: "In-progress",
};

const data = [
    {
        "day": "Monday",
        "responses": []
    },
    {
        "day": "Tuesday",
        "responses": [
            {
                "responseTime": "2025-05-06 21:17:51",
                "quoteId": 1,
                "bookingId": 1,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
        ]
    },
    {
        "day": "Wednesday",
        "responses": [
            {
                "responseTime": "2025-05-06 21:17:51",
                "quoteId": 1,
                "bookingId": 1,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            },
            {
                "responseTime": "2025-05-06 21:17:51",
                "quoteId": 1,
                "bookingId": 1,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            },
            {
                "responseTime": "2025-05-06 21:17:51",
                "quoteId": 1,
                "bookingId": 1,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
            ,
            {
                "responseTime": "2025-05-06 21:17:51",
                "quoteId": 1,
                "bookingId": 1,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
            ,
            {
                "responseTime": "2025-05-06 21:17:51",
                "quoteId": 1,
                "bookingId": 1,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
            ,
            {
                "responseTime": "2025-05-06 21:17:51",
                "quoteId": 1,
                "bookingId": 1,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
        ]
    },
    {
        "day": "Thursday",
        "responses": [
            {
                "responseTime": "2025-05-06 21:17:51",
                "quoteId": 1,
                "bookingId": 1,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
            ,
            {
                "responseTime": "2025-05-06 21:17:51",
                "quoteId": 1,
                "bookingId": 1,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
        ]
    },
    {
        "day": "Friday",
        "responses": [
            {
                "responseTime": "2025-05-09 19:11:57",
                "quoteId": 2,
                "bookingId": 3,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            },
            {
                "responseTime": "2025-05-09 19:49:35",
                "quoteId": 3,
                "bookingId": 2,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            },
            {
                "responseTime": "2025-05-09 19:52:38",
                "quoteId": 13,
                "bookingId": 13,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            },
            {
                "responseTime": "2025-05-09 19:52:38",
                "quoteId": 13,
                "bookingId": 13,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            },
            {
                "responseTime": "2025-05-09 19:52:38",
                "quoteId": 13,
                "bookingId": 13,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            },
            {
                "responseTime": "2025-05-09 19:52:38",
                "quoteId": 13,
                "bookingId": 13,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
            ,
            {
                "responseTime": "2025-05-09 19:52:38",
                "quoteId": 13,
                "bookingId": 13,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
            ,
            {
                "responseTime": "2025-05-09 19:52:38",
                "quoteId": 13,
                "bookingId": 13,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
            ,
            {
                "responseTime": "2025-05-09 19:52:38",
                "quoteId": 13,
                "bookingId": 13,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
            ,
            {
                "responseTime": "2025-05-09 19:52:38",
                "quoteId": 13,
                "bookingId": 13,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
            ,
            {
                "responseTime": "2025-05-09 19:52:38",
                "quoteId": 13,
                "bookingId": 13,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
            ,
            {
                "responseTime": "2025-05-09 19:52:38",
                "quoteId": 13,
                "bookingId": 13,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 9,
                    "fullName": "Liamm",
                    "email": "fasobah@yopmail.com",
                    "phoneNo": "07586924330",
                    "imageUrl": "prod/fasobah/1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "imageThumbUrl": "prod/fasobah/thumb_1753871325974_fasobah_7A97A6E0-4357-4987-AFD6-A760F55FF4DF.jpg",
                    "businessName": "Car Repair Hub",
                    "businessLocation": "A, 405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
        ]
    },
    {
        "day": "Saturday",
        "responses": [
            {
                "responseTime": "2025-05-10 02:48:04",
                "quoteId": 14,
                "bookingId": 14,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 590,
                    "fullName": "Maxwell",
                    "email": "maxwell@yopmail.com",
                    "phoneNo": "12345678900",
                    "imageUrl": "prod/maxwell/1746525236332_maxwell_592A8FDD-7443-4104-8089-25E4FAEAC61A.jpg",
                    "imageThumbUrl": "prod/maxwell/thumb_1746525236332_maxwell_592A8FDD-7443-4104-8089-25E4FAEAC61A.jpg",
                    "businessName": "Maxwell and co",
                    "businessLocation": "405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            },
            {
                "responseTime": "2025-05-10 03:50:11",
                "quoteId": 15,
                "bookingId": 15,
                "status": "ACCEPTED",
                "serviceProvider": {
                    "id": 590,
                    "fullName": "Maxwell",
                    "email": "maxwell@yopmail.com",
                    "phoneNo": "12345678900",
                    "imageUrl": "prod/maxwell/1746525236332_maxwell_592A8FDD-7443-4104-8089-25E4FAEAC61A.jpg",
                    "imageThumbUrl": "prod/maxwell/thumb_1746525236332_maxwell_592A8FDD-7443-4104-8089-25E4FAEAC61A.jpg",
                    "businessName": "Maxwell and co",
                    "businessLocation": "405, Block 5 Gulshan-e-Iqbal, Karachi, 75300, Pakistan",
                    "addressLine1": null,
                    "postalCode": null
                }
            }
        ]
    },
    {
        "day": "Sunday",
        "responses": []
    }
]

const SUProfileDashboard = () => {

    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [suData, setSuData] = useState(null);

    useEffect(() => {
        if (id) {
            (async () => {
                setIsLoading(true)
                try {
                    let resp = await ApiCaller.Get(`/admin/service-user/${id}`);
                    setSuData(resp?.data?.data?.userDetails)
                }
                catch (error) {
                    console.log(error)
                }
                finally {
                    setIsLoading(false)
                }
            })()
        }
    }, [id])

    return (
        <div className="profile-dashboard-container">
            {
                isLoading ?
                    <Col className="user-table-loader-container">
                        <Loader.Circular />
                    </Col>
                    :
                    <>
                        <div className="su-about-main-info-container">
                            <div className='profile-header-section'>
                                <ProfileImage
                                    asAvatar
                                    size={100}
                                    src={suData?.basic?.imageUrl}
                                    className="profile-avatar"
                                />
                                <Title level={4} className="user-name">{suData?.basic?.fullName ?? '-'}</Title>
                                <Text className="user-contact-info">{suData?.basic?.email ?? '-'} | {suData?.basic?.phoneNo ?? '-'}</Text>
                                <Text className="user-address">{suData?.basic?.address}</Text>
                                <Text className="user-status">Service User</Text>
                                <div className="booking-stats">
                                    <div className="booking-stat-item">
                                        <span className="stat-number">{suData?.basic?.totalBookings ?? 0}</span>
                                        <span className="stat-label">Number of Bookings</span>
                                    </div>
                                </div>
                            </div>
                            <div className='su-cards-container'>
                                <Card className="account-card">
                                    <Title level={5} className="card-title">Account & Platform Details</Title>
                                    <Row gutter={[16, 16]} align="middle" style={{ gap: '20px' }}>
                                        <Col>
                                            <div className="detail-item">
                                                <span className='calendar-icon-container'>
                                                    <SlCalender color='#fff' />
                                                </span>
                                                <div className="detail-text-container">
                                                    <Text className="detail-label">Date Joined</Text>
                                                    <Text className="detail-value">{suData?.basic?.joinedAt ? moment(suData?.basic?.joinedAt)?.format('DD MMM YYYY') : "-"}</Text>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="detail-item">
                                                <div className="detail-text-container">
                                                    <Text className="detail-label">Account Status:</Text>
                                                    <Button type="primary" className="status-button active-status">{accountStatus[suData?.basic?.status]}</Button>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>

                                <Card className="engagement-card">
                                    <Title level={5} className="card-title">Engagement</Title>
                                    <div className="engagement-stats-container">
                                        <div className='engagement-stat-item'>
                                            <div className='engagement-icon'>
                                                <img src={requestedEngagement} />
                                            </div>
                                            <div className="engagement-content">
                                                <span className="engagement-number requested-number">{suData?.engagement?.servicesRequested ?? 0}</span>
                                                <Text className="engagement-label">Requested</Text>
                                            </div>
                                        </div>
                                        <div className='engagement-stat-item'>
                                            <div className='engagement-icon'>
                                                <img src={acceptedEngagement} />
                                            </div>
                                            <div className="engagement-content">
                                                <span className="engagement-number accepted-number">{suData?.engagement?.servicesAccepted ?? 0}</span>
                                                <Text className="engagement-label">Accepted</Text>
                                            </div>
                                        </div>
                                    </div>
                                </Card>

                            </div>
                        </div>

                        {/* Account & Platform Details Section */}
                        {/* <Card className="account-card">
                            <Title level={5} className="card-title">Account & Platform Details</Title>
                            <Row gutter={[16, 16]} align="middle" style={{ gap: '20px' }}>
                                <Col>
                                    <div className="detail-item">
                                        <span className='calendar-icon-container'>
                                            <SlCalender color='#fff' />
                                        </span>
                                        <div className="detail-text-container">
                                            <Text className="detail-label">Date Joined</Text>
                                            <Text className="detail-value">{suData?.basic?.joinedAt ? moment(suData?.basic?.joinedAt)?.format('DD MMM YYYY') : "-"}</Text>
                                        </div>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="detail-item">
                                        <div className="detail-text-container">
                                            <Text className="detail-label">Account Status:</Text>
                                            <Button type="primary" className="status-button active-status">{accountStatus[suData?.basic?.status]}</Button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card> */}

                        {/* Type of Services Booked Section */}
                        <Card className="services-card">
                            <Title level={5} className="card-title">Type of services booked</Title>
                            <Row gutter={[16, 16]}>
                                {
                                    suData?.servicesBooked?.length > 0 ?
                                        suData?.servicesBooked?.map((service) => {
                                            return (
                                                <Col xs={12} sm={8} md={4} key={service?.id}>
                                                    <div className="service-type-item">
                                                        <span className='services-icon-container'>
                                                            <FaCheck color='#fff' size={10} />
                                                        </span>
                                                        <Text>{service?.name}</Text>
                                                    </div>
                                                </Col>
                                            )
                                        })

                                        :
                                        <p>No Services Booked</p>
                                }

                            </Row>
                        </Card>

                        <Card style={{marginTop:'1.2rem'}}>
                            <Title level={5} className="card-title">Frequency of bookings</Title>
                            <Row gutter={[16]}>
                                <Col span={24}>
                                    <BookingFrequencyChart id={id} />
                                </Col>
                            </Row>
                        </Card>


                        <Card style={{marginTop:'1.2rem'}}>
                            <Title level={5} className="card-title">Average Spend per booking</Title>
                            <Row gutter={[16]}>
                                <Col span={24}>
                                    <AverageSpendPerBooking id={id} />
                                </Col>
                            </Row>
                        </Card>

                        {/* Engagement Section */}
                        {/* <Card className="engagement-card">
                            <Title level={5} className="card-title">Engagement</Title>
                            <div className="engagement-stats-container">
                                <div className='engagement-stat-item'>
                                    <div className='engagement-icon'>
                                        <img src={requestedEngagement} />
                                    </div>
                                    <div className="engagement-content">
                                        <span className="engagement-number requested-number">{suData?.engagement?.servicesRequested ?? 0}</span>
                                        <Text className="engagement-label">Requested</Text>
                                    </div>
                                </div>
                                <div className='engagement-stat-item'>
                                    <div className='engagement-icon'>
                                        <img src={acceptedEngagement} />
                                    </div>
                                    <div className="engagement-content">
                                        <span className="engagement-number accepted-number">{suData?.engagement?.servicesAccepted ?? 0}</span>
                                        <Text className="engagement-label">Accepted</Text>
                                    </div>
                                </div>
                            </div>
                        </Card> */}


                        <Card style={{marginTop:'1.2rem'}}>
                            <Title level={5} className="card-title">Response rate to expert offers / weekly</Title>
                            <Row gutter={[16]}>
                                <Col span={24}>
                                    <WeeklyResponseRateChart id={id} />
                                </Col>
                            </Row>
                        </Card>

                        <Card className="reviews-card" style={{marginTop:'1.2rem'}}>
                            <Title level={5} className="card-title">Reviews Given</Title>
                            <div className="review-container-wrapper">
                                {/* Review 1 */}
                                {
                                    suData?.reviews?.rows?.length > 0
                                        ?
                                        suData?.reviews?.rows?.map((review) => {
                                            return (
                                                <><div className="review-group">
                                                    <div className="review-item">
                                                        <ProfileImage asAvatar size={40} src={review?.user?.imageThumbUrl} className="review-avatar" />
                                                        <div className="review-content">
                                                            <div className="review-header">
                                                                <span className="reviewer-name">{review?.user?.fullName ?? 'anonymous'}</span>
                                                            </div>
                                                            <div className="rating">
                                                                <Rate value={review?.rating} count={5} disabled allowHalf={true} />
                                                            </div>
                                                            <Text className="review-date">{moment(review?.createdAt)?.format('DD MMM YYYY')} | {moment(review?.createdAt)?.format('HH:MM')}</Text>
                                                            <Text className="review-text">
                                                                {review?.comment}
                                                            </Text>
                                                        </div>
                                                    </div>

                                                    {/* Nested Reply */}
                                                    {
                                                        review?.replyUserId &&
                                                        <div className="review-item nested">
                                                            <ProfileImage asAvatar size={40} src={review?.replyUser?.imageThumbUrl} className="review-avatar" />
                                                            <div className="review-content">
                                                                <div className="review-header">
                                                                    <span className="reviewer-name">{review?.replyUser?.fullName}</span>
                                                                </div>
                                                                <Text className="review-text">
                                                                    {review?.reply}
                                                                </Text>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                    <div className="divider"></div>
                                                </>
                                            )
                                        })
                                        :
                                        <p>No reviews</p>
                                }
                            </div>
                        </Card>
                    </>
            }
        </div >
    );
};

export default SUProfileDashboard;